import React, { Component } from 'react';
import './splashscreen.css';
import { FaArrowRight as Arrow } from 'react-icons/lib/fa';

class SplashScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: false,
    };
  }

  handleChange = () => {
    const { isChecked } = this.state;
    this.setState({
      isChecked: ! isChecked,
    });
  }

  handleSubmit = (e) => {
    const { closeModal } = this.props;
    const { isChecked } = this.state;
    e.preventDefault();
    if (isChecked) {
      localStorage.setItem('DontShow', 'true');
    }
    closeModal();
  }

  render() {
    const { isChecked } = this.state;
    return (
      <div className="analytics-splashscreen">
        <div className="upper-diagram">
          <div className="get-started">
            <div className="header">
              <h6>Get Started with Analytics and Machine Learning for your devices</h6>
            </div>
            <div className="steps">
              <ol>
                <li>Create your first model</li>
                <li>Schedule the job which will find anomalies or predict failures, or events.</li>
                <li>See results of all devices withy anomalies/failures.</li>
                <li>Drill-down to a single device to see its details</li>
              </ol>
            </div>
          </div>

        </div>
        <div className="lower-diagram">
          <div className="user-flow">
            <p>1</p>
            <Arrow size="21" />
            <p>2</p>
            <Arrow size="21" />
            <p>3</p>
            <Arrow size="21" />
            <p>4</p>
            <hr />
          </div>
          <div className="text-container">
            <div className="models-container">
              <h6>Models</h6>
              <div className="models-info">
                <p>Start by creating a model for the problem you are trying to solve.</p>
                <br />
                <p>Here are some examples of models you may create:</p>
                <ul>
                  <li>Show me the list of devices that will need to replace their batteries in 4 weeks</li>
                  <li>
                    {`Show me the list of devices that had anomalies in the last 24 hours.
                    Example of anomalies: abrupt drop in output-temperature, or loss of wireless connectivity`}
                  </li>
                  <li>
                    {`Tell me which devices will need to replenish inventory in 4 weeks
                    (coffee, filter, beverage, etc)`}
                  </li>
                </ul>
              </div>
            </div>
            <div className="schedules-container">
              <h6>Schedules</h6>
              <div className="schedules-info">
                <p>
                  {`After a model is created, schedule the frequency of when you want to find new anomalies, 
                  or predict when devices will fail.`}
                </p>
                <br />
                <p>
                  {`A good practice is to schedule a job to run overnight so that in the morning
                  you have the list of devices with newly found anomalies.`}
                </p>
              </div>
            </div>
            <div className="results-container">
              <h6>Results</h6>
              <div className="results-info">
                <p>
                  {`After you run your first job, you will see the results in this page.
                  You will see the lists of devices that match the problem you’re trying to diagnose.`}
                </p>
                <br />
                <p>You will also see the trends of how many devices have had certain types of anomalies.</p>
                <br />
                <p>From this page you can drill down to a specific device.</p>
              </div>
            </div>
            <div className="device-container">
              <h6>Device Details</h6>
              <div className="device-info">
                <p>
                  {`Here you see the full details of both anomalies and predictive events and failures
                  for a single device.`}
                </p>
                <br />
                <p>You can get here by searching for a device via device serial number (DSN), email, or MAC address.</p>
                <br />
                <p>You can also drill-down from the results page.</p>
              </div>
            </div>
          </div>
        </div>
        <form onSubmit={this.handleSubmit}
          className="dont-show-container"
        >
          <label htmlFor="check">
            {'Don\'t show this again'}
            <input type="checkbox"
              id="check"
              className="dont-show-check"
              checked={isChecked}
              onChange={this.handleChange}
            />
          </label>
          <button type="submit"
            value="Submit"
          >
            {'Close'}
          </button>
        </form>
      </div>
    );
  }
}
export default SplashScreen;
